import React from "react";
import classNames from "classnames";
import { Trans, useTranslation } from "react-i18next";
import { sendNote } from "helpers";
import { Link } from "react-router-dom";
import { ProfileImage } from "components/ImageHandle";

const Profile = (props) => {

	const { t } = useTranslation();
	const { station = {}, is_partner_bj, is_best_bj, is_owner, profile_image, id, path } = props;
	const { user_nick = "", user_id = "", groups } = station;
	const is_setting = path.indexOf("/:id/setting") > -1 ? true : false;
	
	const handleSendNote = () => {
		sendNote(global.bj_id);
	};

	return (
		<section className="bj_box">
			<Link to={`/${global.bj_id}`}>
				<ProfileImage className="thum" src={profile_image} />
			</Link>
			<div className="info_box">
				<div className="nick">
					<h2>{user_nick}</h2>
					{!is_setting && !is_owner && (
						<button type="button" className="msg" tip={t("Gửi tin nhắn")} onClick={handleSendNote}>
							<span>
								<Trans>Ghi chú</Trans>
							</span>
						</button>
					)}
					{is_setting && (
						<Link to={`/${id}`}>
							<button type="button" className="bs" tip={t("Blog")}>
								<span>
									<Trans>Blog</Trans>
								</span>
							</button>
						</Link>
					)}
				</div>
				<span className="id">@{user_id}</span>
				{/* 베스트BJ - best 파트너BJ - partner 올드스쿨 - rate1 뉴비존 -rate1 테크BJ - rate2 시그니처풍선 - rate3 애니BJ - rate4 더빙/라디오 - rate5 핫동각BJ - rate6 */}
				{(is_best_bj || is_partner_bj || groups.length > 0) && (
					<div className="bj_cate">
						{is_partner_bj && (
							<span className="partner">
								<Trans>Partner</Trans>
							</span>
						)}
						{is_best_bj && (
							<span className="best">
								<Trans>Best</Trans>
							</span>
						)}
						{groups &&
							groups.map((group, index) => {
								return (
									<span key={index} className={classNames(`rate${group.group_no}`)}>
										{group.info.group_name}
									</span>
								);
							})}
					</div>
				)}
			</div>
		</section>
	);
}

export default Profile;